import { create } from "zustand"

export type AdminNavItem =
  | "dashboard"
  | "rfqs"
  | "quotations"
  | "orders"
  | "companies"
  | "buyers"
  | "sellers"
  | "payments"
  | "logistics"
  | "complaints"
  | "external-sellers"
  | "notifications"
  | "settings"

interface AdminUIState {
  activeNav: AdminNavItem
  sidebarCollapsed: boolean
  setActiveNav: (nav: AdminNavItem) => void
  toggleSidebar: () => void
  setSidebarCollapsed: (collapsed: boolean) => void
}

export const useAdminUIStore = create<AdminUIState>((set) => ({
  activeNav: "dashboard",
  sidebarCollapsed: typeof window !== "undefined" ? window.innerWidth < 768 : false,
  setActiveNav: (activeNav) => set({ activeNav }),
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
}))
